/**
 * Keeps release-date loading and fallback presentation consistent across every asset view.
 */
import React from 'react';

export const RELEASE_DATE_FALLBACK = '-';

interface ReleaseDateSkeletonProps {
  readonly testId: string;
}

export const ReleaseDateSkeleton: React.FC<ReleaseDateSkeletonProps> = ({
  testId,
}) => (
  <div
    data-testid={testId}
    style={{
      width: '100%',
      height: '1em',
      borderRadius: 4,
      backgroundColor: '#E9EBEF',
      animation: 'pulse 1.5s ease-in-out infinite',
    }}
  />
);
